import React from "react";
import { withRouter } from "react-router";
import { withSnackbar } from "notistack";
import { inject, observer } from "mobx-react";
import _throttle from "lodash/throttle";
import withCustomStyles from "./OrderTilePart.style";
import { _get } from "../utils/HelperUtils";
import { getDeliveryTime } from "../utils/DateUtils";
import {
  DELIVERY_STATUS_MESSAGES,
  PAYFAST_PAYMENT_FORM_CONTAINER
} from "../constatns/AppConstants";
import Collapse from "@material-ui/core/Collapse";
import RetryIcon from "@material-ui/icons/Replay";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import { GButton, GNotice, GStatus, GSummary } from "./ui";
import { formatDate, formatItemCount, formatPrice } from "../utils/FormatUtils";
import LoadMorePart from "./LoadMorePart";
import AddCardCvvPart from "./AddCardCvvPart";
import OrderDetailPart from "./OrderDetailPart";
import SimpleDialogPart from "./SimpleDialogPart";
import CreditCardIconPart from "./CreditCardIconPart";
import VerticalProductsListPart from "../parts/VerticalProductsListPart";
import Box from "@material-ui/core/Box";

// Status pill per order status (dot + word, colour is never the only signal)
const ORDER_STATUS = {
  pending: { label: "Received", tone: "brand" },
  confirmed: { label: "Confirmed", tone: "brand" },
  "in progress": { label: "Being packed", tone: "brand" },
  "in review": { label: "Being packed", tone: "brand" },
  dispatched: { label: "On the way", tone: "brand" },
  delivered: { label: "Delivered", tone: "success" },
  declined: { label: "Declined", tone: "danger" },
  dorment: { label: "Declined", tone: "danger" }
};

@inject("myOrdersStore")
@inject("orderStore")
@inject("productStore")
@inject("uiStore")
@observer
class OrderTilePart extends React.Component {
  state = {
    openConfirmationModal: false,
    openModal: false,
    errorMessage: "",
    selectCvv: false,
    expanded: false,
    orderDetails: null
  };

  handleModalToggle = () => {
    const state = { openModal: !this.state.openModal };
    if (this.state.openModal) {
      state.errorMessage = "";
    }
    this.setState(state);
  };

  // eslint-disable-next-line no-unused-vars
  handlePaymentResponse = (isError, message, order) => {
    this.setState({ errorMessage: message, openModal: isError });
  };

  handleCvvModal = () => this.setState({ selectCvv: !this.state.selectCvv });

  handleRetryPayment = cvv => {
    const {
      props: { order, selectedCard, onRetryPayment },
      handleCvvModal,
      handlePaymentResponse
    } = this;
    const retryBody = {
      card_id: selectedCard.id,
      order_id: order.id,
      cvv
    };
    handleCvvModal();
    onRetryPayment(
      retryBody,
      order => handlePaymentResponse(false, "", order),
      error => {
        if (error && !error.approved) {
          handlePaymentResponse(true, error.message);
        }
      },
      () => {}
    );
  };

  fetchOrderInfo = cb => {
    const {
      props: { order, myOrdersStore, enqueueSnackbar }
    } = this;
    myOrdersStore.fetchOrderDetails(
      order.id,
      data => {
        this.setState({
          orderDetails: data
        });
        cb(data);
      },
      () => {
        enqueueSnackbar(
          "We couldn't load this order. Check your connection and try again.",
          {
            variant: "error"
          }
        );
      },
      () => {
        enqueueSnackbar(
          "We couldn't load this order. Check your connection and try again.",
          {
            variant: "error"
          }
        );
      }
    );
  };

  handleClick = () => {
    const {
      state: { expanded, orderDetails },
      fetchOrderInfo
    } = this;
    this.setState({
      expanded: !expanded
    });
    if (!orderDetails) {
      fetchOrderInfo(() => {});
    }
  };

  addAllProducts = _throttle(
    () => {
      const {
        props: {
          orderStore,
          productStore,
          listName,
          query,
          CTListName,
          enqueueSnackbar
        },
        state: { orderDetails },
        getProduct,
        fetchOrderInfo
      } = this;
      if (!orderDetails) {
        fetchOrderInfo(data => {
          if (data && data.order_items && data.order_items.found) {
            data.order_items.found.map(product => {
              productStore.setSelectedProduct(product);
              orderStore.addOne(
                getProduct(product),
                listName,
                CTListName,
                query
              );
            });
            enqueueSnackbar("Successfully added products to cart!", {
              variant: "success"
            });
          }
        });
      } else {
        if (
          orderDetails &&
          orderDetails.order_items &&
          orderDetails.order_items.found
        ) {
          orderDetails.order_items.found.map(product => {
            productStore.setSelectedProduct(product);
            orderStore.addOne(getProduct(product), listName, CTListName, query);
          });
          enqueueSnackbar("Successfully added products to cart!", {
            variant: "success"
          });
        }
      }
    },
    800,
    { trailing: false }
  );

  getProduct = product => {
    const {
      props: { orderStore }
    } = this;
    const orderStoreProduct = orderStore.all.get(product.id);
    if (
      orderStoreProduct &&
      orderStoreProduct.id &&
      product.order_quantity !== orderStoreProduct.order_quantity
    ) {
      return { ...product, order_quantity: orderStoreProduct.order_quantity };
    }
    return { ...product };
  };

  retryPayfastPayment = () => {
    const {
      props: { order, myOrdersStore },
      handleModalToggle
    } = this;

    handleModalToggle();
    myOrdersStore.retryPayfastPayment(order.id);
  };

  emptyCartAndAddProducts = _throttle(
    () => {
      const {
        props: { orderStore, listName, CTListName },
        addAllProducts
      } = this;
      orderStore.emptyCart(listName, CTListName);
      addAllProducts();
      this.setState({ openConfirmationModal: false });
    },
    1000,
    { trailing: false }
  );

  render() {
    const {
      props: {
        order,
        classes,
        retryOrderId,
        selectedCard,
        retryPaymentState,
        myOrdersStore
      },
      state: {
        orderDetails,
        expanded,
        selectCvv,
        openModal,
        openConfirmationModal,
        errorMessage
      },
      handleRetryPayment,
      handleCvvModal,
      emptyCartAndAddProducts,
      handleModalToggle,
      retryPayfastPayment
    } = this;

    const status = ORDER_STATUS[order.status] || ORDER_STATUS.pending;
    const isDeclined =
      order.status === "declined" || order.status === "dorment";
    const statusMessage = _get(
      DELIVERY_STATUS_MESSAGES,
      order.status,
      "Your order has been received"
    );
    const canRetry =
      order.payment_mode === "card" &&
      order.transaction_status === "FAILED" &&
      Boolean(order.should_retry_payment);

    return (
      <article className={classes.card} aria-labelledby={`order-${order.id}`}>
        {order.id && (
          <>
            <div className={classes.head}>
              <div className={classes.headText}>
                <h2 id={`order-${order.id}`} className={classes.orderTitle}>
                  Order #{order.display_id}
                </h2>
                <span className={classes.when}>
                  {formatDate(order.delivery_end_time)} ·{" "}
                  {order.time_slot ||
                    getDeliveryTime(
                      order.delivery_start_time,
                      order.delivery_end_time
                    )}
                </span>
              </div>
              <GStatus tone={status.tone}>{status.label}</GStatus>
            </div>

            <div className={classes.meta}>
              <span>
                {formatItemCount(order.total_items)} ·{" "}
                <strong className={classes.total}>
                  {formatPrice(order.application_total)}
                </strong>
              </span>
              {order.payment_status_message && (
                <span className={classes.payment}>
                  {order.payment_status_message}
                </span>
              )}
            </div>

            {isDeclined ? (
              <GNotice tone="error" icon={<InfoOutlined />}>
                This order was declined. If you were charged, the amount is
                returned to you.
              </GNotice>
            ) : (
              <p className={classes.statusLine}>{statusMessage}</p>
            )}

            {order.payment_mode === "card" &&
              order.transaction_status === "FAILED" &&
              retryPaymentState === "fetching" &&
              retryOrderId === order.id && <LoadMorePart />}

            <div className={classes.actions}>
              {canRetry && (
                <GButton size="sm" onClick={retryPayfastPayment}>
                  Retry payment
                </GButton>
              )}
              <GButton
                size="sm"
                variant={canRetry ? "secondary" : "primary"}
                onClick={() => this.addAllProducts()}
              >
                Reorder
              </GButton>
              <GButton
                size="sm"
                variant="secondary"
                onClick={() => this.setState({ openConfirmationModal: true })}
              >
                Load as new cart
              </GButton>
              <GButton
                size="sm"
                variant="ghost"
                onClick={this.handleClick}
                aria-expanded={expanded}
                aria-controls={`order-details-${order.id}`}
              >
                {expanded ? "Hide details" : "Details"}
              </GButton>
            </div>

            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <div id={`order-details-${order.id}`} className={classes.details}>
                {!orderDetails &&
                  myOrdersStore.fetchOrderDetailsState === "fetching" && (
                    <LoadMorePart />
                  )}
                {!orderDetails &&
                  myOrdersStore.fetchOrderDetailsState === "fail" && (
                    <GNotice
                      tone="error"
                      action={
                        <GButton
                          size="sm"
                          variant="secondary"
                          icon={<RetryIcon />}
                          onClick={this.handleClick}
                        >
                          Try again
                        </GButton>
                      }
                    >
                      We couldn&apos;t load this order&apos;s items.
                    </GNotice>
                  )}
                {orderDetails && (
                  <>
                    <VerticalProductsListPart
                      products={orderDetails.order_items.found}
                      tile={<OrderDetailPart />}
                    />
                    <GSummary
                      className={classes.summary}
                      rows={[
                        {
                          label: "Subtotal",
                          value: formatPrice(parseInt(orderDetails.amount))
                        },
                        {
                          label: "Delivery",
                          value: Number(orderDetails.delivery_charges)
                            ? formatPrice(orderDetails.delivery_charges)
                            : "Free",
                          tone: Number(orderDetails.delivery_charges)
                            ? undefined
                            : "success"
                        },
                        orderDetails.wallet_amount_used
                          ? {
                              label:
                                orderDetails.wallet_amount_used < 0
                                  ? "Wallet credit used"
                                  : "Pending amount paid",
                              value: formatPrice(
                                orderDetails.wallet_amount_used
                              ),
                              tone:
                                orderDetails.wallet_amount_used < 0
                                  ? "success"
                                  : undefined
                            }
                          : null,
                        {
                          label: "Total",
                          value: formatPrice(order.application_total),
                          strong: true
                        }
                      ]}
                    />
                  </>
                )}
              </div>
            </Collapse>
          </>
        )}
        <SimpleDialogPart
          open={openModal}
          fullWidth
          title={errorMessage && "Error"}
          content={errorMessage}
          onClose={handleModalToggle}
        >
          {!errorMessage && (
            <div>
              <LoadMorePart />
              <Box
                className={classes.payfastPaymentWrap}
                textAlign="center"
                id={PAYFAST_PAYMENT_FORM_CONTAINER}
              />
            </div>
            // <CreditCardListPart
            //   showTitleBar
            //   cards={cards}
            //   allowSelection
            //   isRetryPayment
            //   showCreditCardList
            //   title="Credit or Debit Card"
            //   orderId={order.id}
            //   selectedCard={selectedCard}
            //   onPayment={handlePaymentResponse}
            //   fetchCreditCards={fetchCreditCards}
            //   onPaymentSelection={onPaymentSelection}
            //   fetchCreditCardState={fetchCreditCardState}
            //   selectedPaymentMethod={selectedPaymentMethod}
            //   onToggleModal={() => {
            //     handleModalToggle();
            //     handleCvvModal();
            //   }}
            // />
          )}
        </SimpleDialogPart>
        {selectCvv && (
          <AddCardCvvPart
            open={selectCvv}
            card={selectedCard}
            cardIcon={<CreditCardIconPart type={selectedCard.scheme} />}
            onToggleModal={handleCvvModal}
            onAccept={handleRetryPayment}
          />
        )}
        <SimpleDialogPart
          title="Alert!"
          open={openConfirmationModal}
          onClose={() => {
            this.setState({ openConfirmationModal: false });
          }}
          content="The items in your current cart will be lost."
          isDownloadLinks={false}
          acceptBtnContent="OK"
          cancelBtnContent="Cancel"
          onAccept={emptyCartAndAddProducts}
          onCancel={() => {
            this.setState({ openConfirmationModal: false });
          }}
        />
      </article>
    );
  }
}

export default withRouter(withSnackbar(withCustomStyles(OrderTilePart)));
